import { db } from "@/firebase/init.js";
import {
  collection,
  // Get All Documents
  query,
  orderBy,
  getDocs,
  // Add Document
  doc,
  setDoc,
  deleteDoc,
  updateDoc,
  // Pagination
  limit,
  startAfter,
  where,
} from "firebase/firestore";

const usersModule = {
  namespaced: true,
  state: {
    usersList: [],
    searchResult: [],

    blockList: [],
    isLoading: true,
    isFirstLoading: true,
    // Pagination
    loadingMore: false,
    showLoadingButton: true,
    lastVisible: "",
    orderBy: "created_date",
    // Filter Pagination
    filterLastVisible: "",
    haveMoreFilterData: false,
  },
  getters: {
    getUsers: (state) => state.usersList,
    getBlockUsers: (state) => state.blockList,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoading,
    // Pagination
    isLoadingMore: (state) => state.loadingMore,
    isShowLoadingButton: (state) => state.showLoadingButton,
    // Search
    getSearchResult: (state) => state.searchResult,
    // Filter
    isHaveMoreFilterData: (state) => state.haveMoreFilterData,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },

    // Get All Users
    setUsers: (state, payload) => {
      state.usersList = payload;
    },

    // Change Is Blocked Value
    blockUser: (state, payload) => {
      let element = state.usersList.find((user) => user.user_id == payload);
      element.is_blocked = !element.is_blocked;
    },

    // Add User in BlockList
    addBlockList: (state, payload) => {
      if (state.blockList.length > 0) state.blockList.unshift(payload);
      else state.blockList = [payload];
    },
    // Remove User in BlockList
    removeBlockList: (state, payload) => {
      const findIndex = state.blockList.findIndex(
        (user) => user.user_id == payload
      );
      state.blockList.splice(findIndex, 1);
    },
    // Delete User
    deleteUser: (state, payload) => {
      const findIndex = state.usersList.findIndex(
        (user) => user.user_id == payload
      );
      state.usersList.splice(findIndex, 1);
    },

    // Pagination and Sort and Search
    setData: (state, payload) => {
      state.usersList = payload;
    },
    setNextData: (state, payload) => {
      state.usersList.push(...payload);
    },
    setLoadingMore: (state, payload) => {
      state.loadingMore = payload;
    },
    // Get Search Result
    setSearchResult: (state, payload) => {
      state.searchResult = payload;
    },
    setNextSearchResult: (state, payload) => {
      state.searchResult.push(...payload);
    },
    setLastVisible: (state, payload) => {
      state.lastVisible = payload;
    },
    setOrderBy: (state, payload) => {
      state.orderBy = payload;
    },
    setShowLoadingButton: (state, payload) => {
      state.showLoadingButton = payload;
    },
    setHaveMoreFilterData: (state, payload) => {
      state.haveMoreFilterData = payload;
    },
    // Last Data
    setFilterLastVisible: (state, payload) => {
      state.filterLastVisible = payload;
    },
  },
  actions: {
    //---- Pagination
    async getFirstData({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);
      const data = await getDocs(
        query(
          collection(db, "Users"),
          orderBy(this.state.usersModule.orderBy),
          limit(10)
        )
      );
      const lastVisible = data.docs[data.docs.length - 1] || null;
      commit("setLastVisible", lastVisible);
      let dataArray = [];
      if (!data.empty) {
        data.forEach((doc) => {
          dataArray.push({ user_id: doc.id, ...doc.data() });
        });
      } else {
        dataArray = false;
      }

      if (data.size >= 10) {
        commit("setShowLoadingButton", true);
      } else {
        commit("setShowLoadingButton", false);
      }
      commit("setData", dataArray);
      commit("setLoading", false);
      commit("setFirstLoad", false);
    },

    async getNextData({ commit }) {
      commit("setLoadingMore", true);

      const data = await getDocs(
        query(
          collection(db, "Users"),
          orderBy(this.state.usersModule.orderBy),
          limit(10),
          startAfter(this.state.usersModule.lastVisible)
        )
      );
      const lastVisible = data.docs[data.docs.length - 1] || null;
      commit("setLastVisible", lastVisible);

      let dataArray = [];
      if (!data.empty) {
        data.forEach((doc) => {
          dataArray.push({ user_id: doc.id, ...doc.data() });
        });
      }
      if (data.size >= 10) {
        commit("setShowLoadingButton", true);
      } else {
        commit("setShowLoadingButton", false);
      }
      commit("setNextData", dataArray);
      commit("setLoadingMore", false);
    },

    changeSorting({ commit }, payload) {
      commit("setOrderBy", payload);
    },

    // ----- Search
    async searchData({ commit }, payload) {
      commit("setFirstLoad", false);
      const data = await getDocs(
        query(collection(db, "Users"), where("name", ">=", payload), limit(3))
      );
      let dataArray = [];
      data.forEach((doc) => {
        dataArray.push({ user_id: doc.id, ...doc.data() });
      });
      commit("setSearchResult", dataArray);
    },
    // ----- Filter
    async filterData({ commit }, payload) {
      commit("setLoading", true);
      let dataArray = [];
      const data = await getDocs(
        query(
          collection(db, "Users"),
          where("is_blocked", "==", payload),
          limit(10)
        )
      );
      const lastVisible = data.docs[data.docs.length - 1] || null;
      commit("setFilterLastVisible", lastVisible);
      data.forEach((doc) => {
        dataArray.push({ code_id: doc.id, ...doc.data() });
      });
      if (data.size != 10) {
        commit("setHaveMoreFilterData", false);
      } else {
        commit("setHaveMoreFilterData", true);
      }

      console.log(data.size);
      commit("setSearchResult", dataArray);
      commit("setLoading", false);
    },

    async nextFilterData({ commit }, payload) {
      let dataArray = [];
      const data = await getDocs(
        query(
          collection(db, "Users"),
          where("is_blocked", "==", payload),
          limit(10),
          startAfter(this.state.usersModule.filterLastVisible)
        )
      );
      const lastVisible = data.docs[data.docs.length - 1] || null;
      commit("setFilterLastVisible", lastVisible);

      if (!data.empty) {
        data.forEach((doc) => {
          dataArray.push({ code_id: doc.id, ...doc.data() });
        });
      }
      if (data.size != 10) {
        commit("setHaveMoreFilterData", false);
      } else {
        commit("setHaveMoreFilterData", true);
      }

      commit("setNextSearchResult", dataArray);
    },

    // Block User
    async blockUser({ commit }, payload) {
      updateDoc(doc(db, "Users", payload), {
        is_blocked: true,
      });
      commit("blockUser", payload);
    },

    // Unblock User
    async unblockUser({ commit }, payload) {
      updateDoc(doc(db, "Users", payload), {
        is_blocked: false,
      });
      commit("blockUser", payload);
    },
    // Add User in BlockList
    async addToBlockList({ commit }, payload) {
      await setDoc(doc(db, "BlockedUsers", payload), {
        user_id: payload,
      });
      commit("addBlockList", payload);
    },
    // Remove User in BlockList
    async removeFromBlockList({ commit }, payload) {
      deleteDoc(doc(db, "BlockedUsers", payload));
      commit("removeBlockList", payload);
    },
  },
};

export default usersModule;
